import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './SubscribeForm.css';

const SubscribeForm = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    newsletter: '',
    address: '',
    state: '',
    country: '',
    agree: false,
    terms: false,
    zipcode:'',
  });
const generateCaptcha = () => {
  const a = Math.floor(Math.random() * 10);
  const b = Math.floor(Math.random() * 10);
  return { question: `${a} + ${b}`, answer: a + b };
};

const [captcha, setCaptcha] = useState(generateCaptcha());
const [captchaInput, setCaptchaInput] = useState('');
const [captchaError, setCaptchaError] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
const nameRegex = /^[a-zA-Z\s]+$/;
const emailRegex = /^\S+@\S+\.\S+$/;
const zipRegex = /^\d{6}$|^\d{6}-\d{5}$/;
  const validate = () => {
  const newErrors = {};

  if (!formData.firstname.trim()) {
    newErrors.firstname = 'First name is required.';
  } else if (!nameRegex.test(formData.firstname)) {
    newErrors.firstname = 'First name can only contain letters and spaces.';
  }

  if (!formData.lastname.trim()) {
    newErrors.lastname = 'Last name is required.';
  } else if (!nameRegex.test(formData.lastname)) {
    newErrors.lastname = 'Last name can only contain letters and spaces.';
  }

  if (!formData.email) {
    newErrors.email = 'Email is required.';
  } else if (!emailRegex.test(formData.email)) {
    newErrors.email = 'Please enter a valid email address.';
  }
  if (!formData.zipcode) {
    newErrors.zipcode = 'Zipcode is required.';
  } else if (!zipRegex.test(formData.zipcode)) {
    newErrors.zipcode = 'Please enter a valid zipcode address.';
  }
if (!formData.address.trim()) {
  newErrors.address = 'Message is required.';
} else if (formData.address.length < 10) {
  newErrors.address = 'Message must be at least 10 characters.';
}
if (parseInt(captchaInput) !== captcha.answer) {
  setCaptchaError('Incorrect CAPTCHA answer.');
  return false;
}
  if (!formData.newsletter) newErrors.newsletter = 'newsletter is required.';
 // if (!formData.address.trim()) newErrors.address = 'Address is required.';
  if (!formData.state.trim()) newErrors.state = 'State is required.';
  if (!formData.country.trim()) newErrors.country = 'Country is required.';
  if (!formData.agree) newErrors.agree = 'You must agree to continue.';
  if (!formData.terms) newErrors.terms = 'You must click the check box to continue.';

  // Optional: If you have a ZIP code field
  // if (formData.zip && !zipRegex.test(formData.zip)) {
  //   newErrors.zip = 'ZIP code must be 6 digits or 6 digits + hyphen + 5 digits.';
  // }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);

    try {
      const response = await fetch('https://webvexo.com/sub_web_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Subscribed!',
          text: 'Thanks for subscribing. Check your email for confirmation.',
        });
        setFormData({
          firstname: '',
          lastname: '',
          email: '',
          newsletter: '',
          address: '',
          state: '',
          country: '',
          agree: false,
          terms: false,
          zipcode:'',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Submission failed',
          text: 'Please try again later.',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Network error',
        text: 'Check your connection and try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-5 mb-5">
        <div className="row d-flex justify-content-center mb-5">
            <p className="text-center fw-bold fs-1 color">Subscribe</p>
            <div className="col-md-8">
                <form onSubmit={handleSubmit} className='subscribe-form'>
                    <div className='row'>
                        {[
                        { name: 'firstname', label: 'First Name' },
                        { name: 'lastname', label: 'Last Name' },
                        { name: 'email', label: 'Email', type: 'email' },
                        ].map(({ name, label, type = 'text' }) => (
                            <div className="col-md-4 mb-2" key={name}>
                                <input type={type} name={name} value={formData[name]} onChange={handleChange}
                                className={`form-control ${errors[name] ? 'input-error' : ''}`}
                                placeholder={label}
                                />
                                {errors[name] && <small className="text-danger">{errors[name]}</small>}
                            </div>
                        ))}
                    </div>
                    <div className="row mb-2">
                        <div className='col-md-12'>
                            <textarea
                                name="address"
                                rows="4"
                                value={formData.address}
                                onChange={handleChange}
                                className={`form-control ${errors.address ? 'input-error' : ''}`}
                                placeholder="Write your Address..."
                            ></textarea>
                            {errors.address && <small className="text-danger">{errors.address}</small>}
                        </div>
                    </div>
                    <div className='row'>
                        {[
                        { name: 'country', label: 'Country' },
                        { name: 'zipcode', label: 'zipcode' },
                        ].map(({ name, label, type = 'text' }) => (
                            <div className="col-md-6 mb-2" key={name}>
                                <input type={type} name={name} value={formData[name]} onChange={handleChange}
                                className={`form-control ${errors[name] ? 'input-error' : ''}`}
                                placeholder={label}
                                />
                                {errors[name] && <small className="text-danger">{errors[name]}</small>}
                            </div>
                        ))}
                    </div>
                    <div className="form-group mb-2">
                        <select name="newsletter"  className={`form-control ${errors.newsletter ? 'input-error' : ''}`} value={formData.newsletter} onChange={handleChange}>
                            <option value="">Select Newsletter</option>
                            <option>Daily</option>
                            <option>Weekly</option>
                            <option>No Newsletters</option>
                        </select>
                        {errors.newsletter && <small className="text-danger">{errors.newsletter}</small>}
                    </div>
                    <div className="form-group mb-2">
                        <label className="mb-1 fs-5 fw-bold">What is {captcha.question}?</label>
                        <input
                            type="text"
                            name="captcha"
                            value={captchaInput}
                            onChange={(e) => {
                            setCaptchaInput(e.target.value);
                            setCaptchaError('');
                            }}
                            className={`form-control ${captchaError ? 'input-error' : ''}`}
                            placeholder="Enter answer"
                        />
                        {captchaError && <small className="text-danger">{captchaError}</small>}
                    </div>
                    <div className="form-check mb-3">
                        <input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} className={`form-check-input ${errors.agree ? 'input-error' : ''}`} id="agreeCheck"/>
                        <label className="form-check-label" htmlFor="agreeCheck">
                            I agree to the terms and conditions
                        </label>
                        {errors.agree && <small className="text-danger d-block">{errors.agree}</small>}
                    </div>
                    <div className="form-check mb-3">
                        <input type="checkbox" name="terms" checked={formData.terms} onChange={handleChange} className={`form-check-input ${errors.terms ? 'input-error' : ''}`} id="termsCheck"/>
                        <label className="form-check-label" htmlFor="termsCheck">
                             have read and agree to the <a href="/policy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms and Conditions</a>.
                        </label>
                        {errors.terms && <small className="text-danger d-block">{errors.terms}</small>}
                    </div>

                    <button type="submit" className="insuba-btn text-center w-50 p-2 fs-5 mt-3" disabled={isLoading}>
                    {isLoading ? (
                        <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                        Submitting...
                        </>
                    ) : (
                        'Subscribe'
                    )}
                    </button>
                </form>
            </div>
        </div>
    </div>
  );
};

export default SubscribeForm;
